/**
 * Global configuration for the dashboard application
 */
const config = {
  /**
   * API base URL - can be overridden with REACT_APP_API_URL environment variable.
   * In development (npm start) defaults to local API; in production defaults to api.veritage.io.
   */
  API_BASE_URL:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development' ? 'http://localhost:8082' : 'https://api.veritage.io'),
};

export default config;
